import React, { useState, useEffect, useRef } from "react";
import { NavLink, useHistory } from "react-router-dom"; // ✅ useHistory au lieu de useNavigate
import "./NavbarPrimary.css";
import { primaryNavigation, modelingViews, leanTools } from "./navigationConfig";

const NavbarPrimary = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);
  const history = useHistory(); // ✅ React Router v5

  // Ferme le menu si clic en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (menuLabel) => {
    setOpenMenu(openMenu === menuLabel ? null : menuLabel);
  };

  const getSubMenu = (label) => {
    if (label === "Modeling") return modelingViews;
    if (label === "Management") return leanTools;
    return [];
  };

  const handleNavigation = (path) => {
    history.push(path); // ✅ version v5
    setOpenMenu(null);
  };

  return (
    <nav className="navbar" ref={menuRef}>
      <ul className="nav-list">
        {primaryNavigation.map((item, index) => {
          const subItems = getSubMenu(item.label);
          const isOpen = openMenu === item.label;

          return (
            <li
              key={index}
              className={`nav-item ${subItems.length ? "has-submenu" : ""}`}
            >
              {subItems.length > 0 ? (
                <>
                  <button
                    className="nav-link-button"
                    onClick={() => toggleMenu(item.label)}
                  >
                    {item.label}
                    <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
                  </button>

                  {isOpen && (
                    <div className="submenu-wrapper">
                      <ul className="submenu">
                        {subItems.map((sub, subIndex) => (
                          <li key={subIndex}>
                            <button
                              className="submenu-link"
                              onClick={() => handleNavigation(sub.path)}
                            >
                              {sub.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <NavLink
                  to={item.path}
                  className="nav-link"
                  activeClassName="active"
                  exact={item.exact}
                  onClick={() => setOpenMenu(null)}
                >
                  {item.label}
                </NavLink>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default NavbarPrimary;







